import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { THEMES, THEME_NAMES, DEFAULT_THEME, STORAGE_KEY } from './themes';

const ThemeContext = createContext({
  themeName: DEFAULT_THEME,
  theme: THEMES[DEFAULT_THEME],
  setThemeName: () => {},
  themeNames: THEME_NAMES,
});

function readStoredTheme() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && THEMES[stored]) return stored;
  } catch (_) {}
  return DEFAULT_THEME;
}

function applyThemeVars(theme) {
  const root = document.documentElement;
  root.style.setProperty('--c-cream', theme.cream);
  root.style.setProperty('--c-ink', theme.ink);
  root.style.setProperty('--c-yellow', theme.yellow);
  root.style.setProperty('--c-pink', theme.pink);
  root.style.setProperty('--c-blue', theme.blue);
  root.style.setProperty('--c-green', theme.green);
}

export function ThemeProvider({ children }) {
  const [themeName, setThemeNameState] = useState(readStoredTheme);
  const theme = THEMES[themeName] || THEMES[DEFAULT_THEME];

  useEffect(() => {
    applyThemeVars(theme);
    try { window.localStorage.setItem(STORAGE_KEY, themeName); } catch (_) {}
  }, [theme, themeName]);

  const value = useMemo(() => ({
    themeName,
    theme,
    setThemeName: (name) => { if (THEMES[name]) setThemeNameState(name); },
    themeNames: THEME_NAMES,
  }), [themeName, theme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
